declare namespace $ {

	export class $shm_hitalama_profile_enter extends $shm_hitalama_profile_register {
		pull_pass_keys( ): any
		title( ): string
		submit_title( ): string
		auto( ): readonly(any)[]
		message_incorrect_pass( ): string
	}
	
}

//# sourceMappingURL=enter.view.tree.d.ts.map